import { Link } from "react-router-dom";
import styled from "styled-components";
// 메인 소식 카드: 이미지가 있으면 썸네일, 없으면 순번(01, 02 …)을 왼쪽에 둔다. link 가 http(s) 주소면 새 창 외부 링크
const HomeCard = ({
  content: {
    category = "",
    title = "",
    author = "",
    link = "",
    date = new Date().toLocaleDateString(),
    image = null,
    imageStyle,
  },
  index,
}) => {
  const external = /^https?:/.test(link);
  return (
    <A {...(external ? { as: "a", href: link, target: "_blank", rel: "noopener noreferrer" } : { to: link })}>
      {image ? (
        <Thumb style={{ backgroundImage: `url(${image})`, ...imageStyle }} aria-hidden="true" />
      ) : (
        <No aria-hidden="true">{String((index ?? 0) + 1).padStart(2, "0")}</No>
      )}
      <div className="body">
        {category && <span className="category">{category}</span>}
        <span className="title">{title}</span>
        <span className="info">
          <span>{date}</span>
          {author && <span>{author}</span>}
        </span>
      </div>
    </A>
  );
};
export default HomeCard;
const A = styled(Link)`
  display: flex;
  gap: 1.1rem;
  align-items: flex-start;
  padding: 1.15rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  & > .body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    & > .category {
      align-self: flex-start;
      padding: 0.15rem 0.6rem;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 700;
      background-color: ${({ theme }) => theme.colors.accentSoft};
      color: ${({ theme }) => theme.colors.accent};
    }
    & > .title {
      font-size: 1.05rem;
      font-weight: 600;
      line-height: 1.5;
      color: ${({ theme }) => theme.colors.foreground.normal};
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      transition: color 0.15s;
    }
    & > .info {
      display: flex;
      gap: 0.75rem;
      font-size: 0.85rem;
      color: ${({ theme }) => theme.colors.monotone.medium};
    }
  }
  &:hover > .body > .title {
    color: ${({ theme }) => theme.colors.accent};
  }
`;
const Thumb = styled.span`
  flex: 0 0 5.5rem;
  height: 5.5rem;
  border-radius: 0.75rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.colors.accentSoft};
`;
const No = styled.span`
  flex: 0 0 2.5rem;
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.light};
`;
